import React, { useEffect, useState } from 'react'
import styles from './Slider.module.scss'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getSlider } from './actions'
import Sliders from './Sliders/Sliders'
import { useSelector } from 'react-redux'
import SliderView from './Slider/Slider'
import { Spin } from 'antd'
import { getCategories, getSubjects } from '../Questions/actions'

function Slider() {

  const isLoaded = useSelector(state => state.slider.isLoaded)
  const dispatch = useDispatch()
  let { id } = useParams();
  useEffect(() => {
    dispatch(getSlider(id))
    dispatch({type: 'SET_MENU_KEY', key: 'menu', data: [
      {title: 'mn_dashboard', url: '/dashboard'},
      {title: 'mn_slider', url: '/sliders'}
    ]})
    return () => {
      dispatch({type: 'SET_MENU_KEY', key: 'menu', data: []})
    };
  }, [])

  return (
    <div className={classNames('row', styles.Slider)}>
      {!isLoaded && <div className={styles.spinner}>
        <Spin size='large' />
      </div>}
      <Sliders/>
      <SliderView/>
    </div>
  )
}

export default Slider